/**
 * 处理mixer和clip数据，clip使用nodeptr来保证唯一
 * @param {list} nodes node数据
 */
const formMixerClip = async (nodesList, mixerName) => {
  const res = []
  for (let i = 0; i < nodesList.length; i += 1) {
    res.push({
      mixer: mixerName,
      clipName: nodesList[i].nodePtr
    })
  }
  return res
}

/**
 * 处理mixer和clip数据，clip使用nodeptr来保证唯一
 * @param {list} nodes node数据
 */
const formClipAction = async (clipsList, mixerName) => {
  const res = []
  for (let i = 0; i < clipsList.length; i += 1) {
    res.push({
      mixer: mixerName,
      clip: clipsList[i]
    })
  }
  return res
}

/**
 * 批量向片段中添加轨道数据
 * @param {list} nodes node数据
 */
const formTracks = async (nodesList, clips) => {
  const res = []
  for (let i = 0; i < nodesList.length; i += 1) {
    const tempObj = {
      node: nodesList[i].nodePtr,
      clip: clips[i],
      trackParam: {
        trackType: nodesList[i].trackParam.trackType,
        propertyLinkType: nodesList[i].trackParam.propertyLinkType,
      }
    }
    res.push(tempObj)
  }
  return res
}

/**
 * 批量向片段中添加轨道数据
 * @param {list} nodesList node数据
 */
const formKeys = async (nodesList, trackList) => {
  const res = []
  for (let i = 0; i < nodesList.length; i += 1) {
    for (let j = 0; j < nodesList[i].path.length; j += 1) {
      const tempObj = {
        keyframeTrack: trackList[i],
        value: nodesList[i].path[j],
        time: nodesList[i].time[j],
      }
      res.push(tempObj)
    }
  }
  return res
}


/**
 * 批量向片段中添加轨道数据
 * @param {list} nodesList node数据
 */
const formLoops = async (nodesList, actionList) => {
  const res = []
  for (let i = 0; i < nodesList.length; i += 1) {
    res.push({
      action: actionList[i],
      loopMode: nodesList[i].loopMode,
      repetitions: nodesList[i].repetitions,
    })
  }
  return res
}

/**
 * @param {arr} nodes 需要渲染的node列表
 * @param {obj} baseData 基础数据
 */
const batchAnimation = async (nodes, player) => {
  // const data = new Date()
  // console.log(data, 'begin')
  // // mixer clip action
  const mixer = await player.Native.AnimationMixer.getMixer('mr')
  const mixerClipList = await formMixerClip(nodes, mixer) // 前端处理数据
  const clipsList = await player.Native.AnimationClip.getBatchClips(mixerClipList) // 用mixer获取clip
  const clipActionList = await formClipAction(clipsList, mixer) // 前端处理数据
  const actionList = await player.Native.AnimationAction.getBatchclipActions(clipActionList) // 用clip获取action
  // track
  await player.Native.KeyframeTrack.batchClearTrack(clipsList) // 传入clip清除track，昨天的测试中暂时屏蔽了该接口
  const tracksParam = await formTracks(nodes, clipsList) // 前端处理数据
  const trackList = await player.Native.KeyframeTrack.batchAddTracksWithParam(tracksParam) // 获取track
  await player.Native.KeyframeTrack.batchKeyClear(trackList) // 之前走到这里造成黑屏的接口
  const trackkeysList = await formKeys(nodes, trackList) // 前端处理数据
  await player.Native.KeyframeTrack.batchKeyAppend(trackkeysList)
  // play
  const loops = await formLoops(nodes, actionList)
  await player.Native.AnimationAction.batchSetLoop(loops)
  await player.Native.AnimationAction.batchPlay(actionList)
  return { clipsList }
  // const data7 = new Date()
  // console.log(data7, 'end')
}

export default batchAnimation
